import React, { useState } from "react";
import { Modal, Dropdown, Tab, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import DataTable from 'react-data-table-component';

function MiningAccount() {
    const [showShareWatcher, setShowShareWatcher] = useState(false);
    const [showEditRemark, setShowEditRemark] = useState(false);
    const [showFB, setShowFB] = useState(false);
    const [showTransferEarnings, setShowTransferEarnings] = useState(false);
    const [showTrusted, setShowTrusted] = useState(false);
    const [showHashrate, setShowHashrate] = useState(false);
    const [searchText, setSearchText] = useState('');

    // Data definition for DataTable
    const accountsData = {
        columns: [
            {
                name: "MINING ACCOUNT NAME",
                selector: row => row.name,
                sortable: true,
                cell: row => <strong>{row.name}</strong>
            },
            {
                name: "REMARK",
                selector: row => row.remark,
                sortable: true,
                cell: row => (
                    <a href="#!" onClick={() => setShowEditRemark(true)}>
                        <i className="bi bi-pencil"></i>
                    </a>
                )
            },
            {
                name: "OPERATION",
                selector: row => row.operation,
                cell: row => (
                    <>
                        <a href="#!" className="me-3" onClick={() => setShowShareWatcher(true)}>
                            Watcher Link
                        </a>

                        <Link to={`${process.env.PUBLIC_URL}/mining/statistics`} title="View Mining Account" className="me-3">
                            View
                        </Link>

                        <Dropdown className="d-inline">
                            <Dropdown.Toggle as="a" href="#!" className="text-warning" id="dropdown-basic">
                                More settings
                            </Dropdown.Toggle>

                            <Dropdown.Menu>
                                <Dropdown.Item onClick={() => setShowFB(true)}>Add FB Address</Dropdown.Item>
                                <Dropdown.Item onClick={() => setShowTransferEarnings(true)}>Transfer Earnings</Dropdown.Item>
                                <Dropdown.Item onClick={() => setShowTrusted(true)}>Trusted Account</Dropdown.Item>
                                <Dropdown.Item onClick={() => setShowHashrate(true)}>Hashrate Transfer</Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </>
                )
            },
        ],
        rows: [
            { id: 1, name: 'John Quinn', remark: '', operation: '' },
        ]
    };

    // Filter function for search
    const filterData = (data) => {
        if (!searchText) return data;

        return data.filter(item => {
            return Object.values(item).some(val =>
                String(val).toLowerCase().includes(searchText.toLowerCase())
            );
        });
    };

    return (
        <>
            {/* Body: Titel Header */}
            <div className="body-header border-bottom d-flex py-3">
                <div className="container-xxl">
                    <div className="row align-items-center g-2">
                        <div className="col">
                            {/* Pretitle */}
                            <h1 className="h4 mt-1">Mining Accounts Settings</h1>
                        </div>
                    </div>
                </div>
            </div>

            {/* Body: Body */}
            <div className="body d-flex py-3">
                <div className="container-xxl">

                    <div className="card">
                        <div className="card-body">
                            {/* Search Box */}
                            <div className="row mb-3">
                                <div className="col-sm-12 col-md-12">
                                    <div id="myDataTable_filter" className="dataTables_filter">
                                        <label className='d-flex align-items-center justify-content-end'>
                                            Search:
                                            <div className='mx-1'>
                                                <input
                                                    type="search"
                                                    className="form-control"
                                                    value={searchText}
                                                    onChange={(e) => setSearchText(e.target.value)}
                                                    placeholder="Search..."
                                                />
                                            </div>
                                        </label>
                                    </div>
                                </div>
                            </div>

                            <DataTable
                                columns={accountsData.columns}
                                data={filterData(accountsData.rows)}
                                pagination
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[5, 10, 15, 20]}
                                selectableRows={false}
                                className="table myDataTable table-hover align-middle mb-0 d-row nowrap dataTable no-footer dtr-inline"
                                highlightOnHover={true}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Share to Watcher Modal */}
            <Modal show={showShareWatcher} onHide={() => setShowShareWatcher(false)} centered size="lg">
                <Modal.Header closeButton className="border-0">
                    <Modal.Title>Share to Watcher</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Tab.Container defaultActiveKey="btc">
                        {/* Coin Tabs */}
                        <Nav variant="tabs" className="tab-body-header rounded d-inline-flex mb-4">
                            <Nav.Item><Nav.Link eventKey="btc">BTC</Nav.Link></Nav.Item>
                            <Nav.Item><Nav.Link eventKey="bch">BCH</Nav.Link></Nav.Item>
                            <Nav.Item><Nav.Link eventKey="eth">ETH</Nav.Link></Nav.Item>
                            <Nav.Item><Nav.Link eventKey="ltc">LTC</Nav.Link></Nav.Item>
                            <Nav.Item><Nav.Link eventKey="etc">ETC</Nav.Link></Nav.Item>
                            <Nav.Item><Nav.Link eventKey="zec">ZEC</Nav.Link></Nav.Item>
                            <Nav.Item><Nav.Link eventKey="ethw">ETHW</Nav.Link></Nav.Item>
                        </Nav>

                        <Tab.Content>
                            <Tab.Pane eventKey="btc">
                                <label className="form-label">Create A New Watcher Link</label>
                                <input type="text" className="form-control mb-4" placeholder="Name for the new Watcher link" />

                                <h6>Watcher permissions</h6>
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" id="stats" />
                                    <label className="form-check-label" htmlFor="stats">Statistics</label>
                                </div>
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" id="workers" defaultChecked />
                                    <label className="form-check-label" htmlFor="workers">Workers</label>
                                </div>
                                <div className="form-check mb-4">
                                    <input className="form-check-input" type="checkbox" id="earnings" />
                                    <label className="form-check-label" htmlFor="earnings">Earnings</label>
                                </div>

                                <h6>Operation authority</h6>
                                <div className="form-check mb-2">
                                    <input className="form-check-input" type="checkbox" id="deleteMiners" />
                                    <label className="form-check-label" htmlFor="deleteMiners">Allow to delete miners</label>
                                </div>
                                <div className="form-check mb-4">
                                    <input className="form-check-input" type="checkbox" id="grouping" />
                                    <label className="form-check-label" htmlFor="grouping">Allow grouping</label>
                                </div>

                                <button className="btn btn-warning w-100">Create</button>
                            </Tab.Pane>
                            {/* Other tabs content would go here, simplified for now as duplicates of BTC structure usually */}
                            <Tab.Pane eventKey="bch"><div className="text-center p-3">Content for BCH</div></Tab.Pane>
                            <Tab.Pane eventKey="eth"><div className="text-center p-3">Content for ETH</div></Tab.Pane>
                            <Tab.Pane eventKey="ltc"><div className="text-center p-3">Content for LTC</div></Tab.Pane>
                            <Tab.Pane eventKey="etc"><div className="text-center p-3">Content for ETC</div></Tab.Pane>
                            <Tab.Pane eventKey="zec"><div className="text-center p-3">Content for ZEC</div></Tab.Pane>
                            <Tab.Pane eventKey="ethw"><div className="text-center p-3">Content for ETHW</div></Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </Modal.Body>
            </Modal>

            {/* Edit Remark Modal */}
            <Modal show={showEditRemark} onHide={() => setShowEditRemark(false)} centered>
                <Modal.Header closeButton className="border-0">
                    <Modal.Title>Edit remark</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <label className="form-label">Remark</label>
                    <input type="text"
                        className="form-control mb-4"
                        placeholder="Add remark for Mining Account John Quinn" />
                    <button className="btn btn-warning w-100">Save</button>
                </Modal.Body>
            </Modal>

            {/* ADD FB ADDRESS */}
            <Modal show={showFB} onHide={() => setShowFB(false)} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Add FB Address</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="small text-muted">
                        Before adding or changing your address, confirm the minimum deposit amount.
                    </p>
                    <label className="form-label">Earnings Address</label>
                    <input className="form-control mb-3" placeholder="Enter the earnings address" />

                    <label className="form-label">Sync with Accounts (Optional)</label>
                    <select className="form-select">
                        <option>Select mining account</option>
                        <option>John Quinn</option>
                    </select>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-warning w-100">Next</button>
                </Modal.Footer>
            </Modal>

            {/* TRANSFER EARNINGS */}
            <Modal show={showTransferEarnings} onHide={() => setShowTransferEarnings(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Transfer Earnings</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <label className="form-label">Transfer to</label>
                    <div className="input-group mb-3">
                        <input className="form-control" placeholder="Please enter Mining ID" />
                        <button className="btn btn-outline-warning">Check</button>
                    </div>

                    <label className="form-label">Transfer proportion (%)</label>
                    <input className="form-control mb-3" placeholder="Enter percentage" />

                    <label className="form-label">Transfer Coin</label>
                    <div className="d-flex flex-wrap gap-2 mb-3">
                        <span className="badge bg-light text-dark border">BTC</span>
                        <span className="badge bg-light text-dark border">BCH</span>
                        <span className="badge bg-light text-dark border">LTC</span>
                        <span className="badge bg-light text-dark border">DOGE</span>
                        <span className="badge bg-light text-dark border">ETC</span>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-warning w-100">Save</button>
                </Modal.Footer>
            </Modal>

            {/* TRUSTED ACCOUNT */}
            <Modal show={showTrusted} onHide={() => setShowTrusted(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Trusted Account</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p className="small text-muted">
                        Authorize a third-party account to view mining data.
                    </p>

                    <label className="form-label">Coin</label>
                    <div className="d-flex flex-wrap gap-2 mb-3">
                        <span className="badge bg-light text-dark border">BTC</span>
                        <span className="badge bg-light text-dark border">BCH</span>
                        <span className="badge bg-light text-dark border">LTC</span>
                        <span className="badge bg-light text-dark border">ETC</span>
                        <span className="badge bg-light text-dark border">ZEC</span>
                    </div>

                    <label className="form-label">Trusted Pool ID</label>
                    <input className="form-control" placeholder="Please set the trusted pool ID" />
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-warning w-100">Done</button>
                </Modal.Footer>
            </Modal>

            {/* HASHRATE TRANSFER */}
            <Modal show={showHashrate} onHide={() => setShowHashrate(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Hashrate Transfer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <label className="form-label">Mining Account Transfer</label>
                    <input className="form-control mb-3" />

                    <label className="form-label">Transfer Period</label>
                    <input className="form-control mb-3" placeholder="YYYY-MM-DD → YYYY-MM-DD" />

                    <label className="form-label">Transfer Coin</label>
                    <div className="d-flex flex-wrap gap-2 mb-3">
                        <span className="badge bg-light text-dark border">BTC</span>
                        <span className="badge bg-light text-dark border">BCH</span>
                        <span className="badge bg-light text-dark border">LTC</span>
                        <span className="badge bg-light text-dark border">ETC</span>
                    </div>

                    <label className="form-label">Transfer Amount (TH/s)</label>
                    <input className="form-control" />
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-warning w-100">Save</button>
                </Modal.Footer>
            </Modal>
        </>
    )
}
export default MiningAccount;
